import React from 'react';
import Reveal from './Reveal';
import { TelegramIcon, XIcon, MailIcon, ArrowIcon } from './icons';
import { TG_URL, X_URL, EMAIL, ALCOR_SWAP, DISCLAIMER } from '../data';
import pepe from '../../public/love.webp';
import '../styles/community.css';

const Community = () => (
  <section className="section community" id="contact">
    <Reveal className="community-panel glass">
      <img className="community-pepe" src={pepe} alt="" aria-hidden="true" loading="lazy" />
      <div className="community-inner">
        <span className="eyebrow">join the swamp</span>
        <h2 className="community-title">ready to ride with <span className="accent">$KEK</span>?</h2>
        <p className="community-lead">
          The frogs are organizing. Join community channels at your own risk; $KEK is
          provided for entertainment only and has no intrinsic value or expectation of
          financial return.
        </p>

        <div className="community-actions">
          <a className="btn btn-primary" href={ALCOR_SWAP} target="_blank" rel="noopener noreferrer">View on Alcor <ArrowIcon /></a>
          <a className="community-social" href={TG_URL} target="_blank" rel="noopener noreferrer" aria-label="Telegram"><TelegramIcon /><span>Telegram</span></a>
          <a className="community-social" href={X_URL} target="_blank" rel="noopener noreferrer" aria-label="X / Twitter"><XIcon /><span>X / Twitter</span></a>
          <a className="community-social" href={`mailto:${EMAIL}`} aria-label="Email"><MailIcon /><span>Email</span></a>
        </div>
      </div>
    </Reveal>

    <Reveal className="community-disclaimer" delay={0.1}>
      <p>{DISCLAIMER}</p>
    </Reveal>
  </section>
);

export default Community;
